module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "block-btn md-btn wish-btn",
    on: {
      "click": _vm.addWish
    }
  }, [_vm._v("위시리스트 저장")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9ff46e50"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/main/education/AddWishButton.vue
// module id = 1489
// module chunks = 6